import script from "./MarketplaceCategoriesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MarketplaceCategoriesList.vue?vue&type=script&lang=ts&setup=true"

import "./MarketplaceCategoriesList.vue?vue&type=style&index=0&id=04969498&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04969498"]])

export default __exports__